/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Notes_LabelInputs */

const en_site_notes_label = /** @type {(inputs: Site_Notes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What do you want to build? (optional)`)
};

const id_site_notes_label = /** @type {(inputs: Site_Notes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mau bikin apa? (opsional)`)
};

/**
* | output |
* | --- |
* | "What do you want to build? (optional)" |
*
* @param {Site_Notes_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_notes_label = /** @type {((inputs?: Site_Notes_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Notes_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_notes_label(inputs)
	return en_site_notes_label(inputs)
});